import {useEffect, useState} from 'react';

import {Location} from 'history';
import {DefaultRootState, useSelector} from 'react-redux';
import {InjectedRouter} from 'react-router/lib/Router';

import {
  InverseFetch,
  InverseLocation,
  revertLocationParamsConvertion,
} from './store/sweet-api/utils';
import {shallowEqual} from './utils/react-utils';

export function useLocalStateFilters<
  FetchParamsType extends InverseFetch,
  LocationParamsType extends InverseLocation<FetchParamsType>
>(convertParamsFunction: (params: LocationParamsType) => FetchParamsType) {
  // a filters saving hook that will work on most dashboards doesn't store in redux though.
  function useLocalStateFiltersWrapper(
    location: Location<FetchParamsType>,
    router: InjectedRouter
  ) {
    const [filters, setFilters] = useState(
      revertLocationParamsConvertion({} as FetchParamsType)
    );

    return useGenericFilters(
      location,
      router,
      () => filters,
      (payload) => setFilters(revertLocationParamsConvertion(payload)),
      convertParamsFunction
    );
  }

  return useLocalStateFiltersWrapper;
}
export function useGenericFilters<
  FetchParamsType extends InverseFetch,
  LocationParamsType extends InverseLocation<FetchParamsType>
>(
  location: Location<FetchParamsType>,
  router: InjectedRouter,
  selector: (state: DefaultRootState) => LocationParamsType,
  setFilters: (payload: FetchParamsType) => any,
  convertParamsFunction: (params: LocationParamsType) => FetchParamsType
) {
  const filters = useSelector(selector);

  useEffect(() => {
    setFilters({...location.query});
  }, [location.query]);

  const resetFilters = () => {
    setFilters({} as FetchParamsType);
    router.replace({pathname: location.pathname});
  };

  const viewingAll = shallowEqual(
    convertParamsFunction({} as any),
    convertParamsFunction(filters)
  );

  return {
    filters,
    params: convertParamsFunction({
      ...location.query,
      ...filters,
    }),
    viewingAll,
    resetFilters,
    setFilters,
  };
}
